<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ $t('settings.delete_user.confirmation.title') }}
      </p>
    </header>
    <section class="modal-card-body">
      <p>{{ $t('settings.delete_user.confirmation.message') }}</p>
    </section>
  </div>
</template>

<script>

import Auth from 'services/Auth';

export default {
  name: "DeletionRequestConfirmation",
  mounted() {
    setTimeout(()=> Auth.logout(), 5000)
  },
};

</script>
